import { render, staticRenderFns } from "./artificialList.vue?vue&type=template&id=01fa54e4&scoped=true&"
import script from "./artificialList.vue?vue&type=script&lang=js&"
export * from "./artificialList.vue?vue&type=script&lang=js&"
import style0 from "./artificialList.vue?vue&type=style&index=0&id=01fa54e4&scoped=true&lang=css&"
import style1 from "./artificialList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fa54e4",
  null
  
)

export default component.exports